module.exports = __webpack_public_path__ + "static/media/DilarasWegtraeumGeschichten.ffc338ef.jpg";